import { defineStore } from "pinia";
import rechercheApiDrive from "@/services/http/api-drive/magasin/recherche";
import produitApiDrive from "@/services/http/api-drive/magasin/produit/productInfo";
import { useMagasinStore } from './magasin';

export const StatusTypes = {
  SIMILAIRES_REQUEST: 'SIMILAIRES_REQUEST',
  SIMILAIRES_SUCCESS: 'SIMILAIRES_SUCCESS'
}

export const useProduitsSimilairesStore = defineStore({
  id: 'produits-similaires',
  state: () => {
    return {
      similaires: [],
      produit: null,
      status: null
    }
  },
  actions: {
    setSimilaires(similaires) {
      this.similaires = similaires;
    },
    resetSimilaires() {
      this.similaires = [];
      this.status = null;
    },
    similairesRequest(produit) {
      this.produit = produit;
      this.status = StatusTypes.SIMILAIRES_REQUEST;
    },
    similairesSuccess() {
      this.status = StatusTypes.SIMILAIRES_SUCCESS;
    },

    async fetchSimilaires(produit) {
      const magasinStore = useMagasinStore();
      this.similairesRequest(produit);
      try {
        const { data } = await this.$apiDrive.use(produitApiDrive).productInfo({
          shopId: magasinStore.id,
          productId: produit.id
        });
        if (data.attributes.associations.similaire.data) {
          this.setSimilaires(data.attributes.associations.similaire.data);
        }
      } catch (err) {
        // rien à faire
      } finally {
        this.similairesSuccess();
      }
    },
    async fetchSimilairesIndispo(produit) {
      const magasinStore = useMagasinStore();
      this.similairesRequest(produit);
      try {
        const { data } = await this.$apiDrive.use(rechercheApiDrive).search({
          shopId: magasinStore.id,
          keyWords: produit.attributes.designation
        });
        if (data.attributes.product_list.data) {
          const similaires = data.attributes.product_list.data.filter((item) => {
            return item.attributes.en_stock;
          });
          this.setSimilaires(similaires.splice(0, 10));
        }
      } catch (err) {
        // rien à faire
      } finally {
        this.similairesSuccess();
      }
    }
  }
})